module.exports = __webpack_public_path__ + "img/Warningsign.bb899382.png";